import { IComponentOptions } from "angular";
import { PartTransactionItemController } from "../partTransactionItemController";

export const vsComponentName = "partTransactionDetailMachinePart";

export const partTransactionDetailMachinePartComponent: IComponentOptions = {
  bindings: {
    item: "<",
  },
  controller: PartTransactionItemController,
  controllerAs: "ctrl",
  template: require("!html-loader!./index.html").default,
};
